export const isDEV = false;

export const applicationIdType = {
  rajasthan: "rajasthan",
  punjab: "punjab",
};

export const InstituteNames = {
  NMTI: "National Midwifery Training Institute",
  SMTI: "State Midwifery Training Institute.",
};

export const CloudFunctionNames = {
  updateUserPassword: `${isDEV ? "dev_" : ""}updateUserPassword`,
  deleteUser: `${isDEV ? "dev_" : ""}deleteUser`,
  forgotPassword: `${isDEV ? "dev_" : ""}forgotPassword`,
  createdashboarduserv2: `${isDEV ? "dev_" : ""}createdashboarduserv2`,
  sample: `${isDEV ? "dev_" : ""}sample`,
};


export const INSTITUTE = ["SMTI", "NMTI"]
export const STATES = ["Rajasthan", "Delhi"]